<template>
	<div :class="{ 'isLoading': isLoading }" class="reduce-div">
		<transition-group name="fade">
			<v-text-field
				key="input"
				v-if="!isLoading"
				hide-details
				background-color="white"
				class="base-input"
				v-bind="$attrs"
				:height="height"
				:value="value"
				@input="sendValue"
				@blur="blurAction"
			/>
			<span class="error-style" v-if="!isLoading" key="error">
				<slot name="error"></slot>
			</span>
		</transition-group>
	</div>
</template>
<script>

function blurAction(val) {
	this.$emit('blur', val);
}

function sendValue(val) {
	this.$emit('input', val);
}

export default {
	name: 'base-input',
	inheritAttrs: false,
	methods: {
		blurAction,
		sendValue,
	},
	props: {
		height: {
			default: 30,
			type: Number,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		value: null,
	},
};
</script>
<style lang="scss" scoped>
.reduce-div{
	font-family: 'AvenirRegular';
	font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/base-input.vue